import withRouter from 'react-router/lib/withRouter';
import { compose, lifecycle, withHandlers } from 'recompose';

import Assignments from '../components/Assignments';
import {
  getPath,
  getAssignment,
  getFieldValue,
  convertAssignmentsIntoObject,
} from '../utils';
import withEntitiesLoading from '../hoc/assignments/withEntitiesLoading';
import withShopExpander from '../hoc/assignments/withShopExpander';
import withServiceAssignments from '../hoc/assignments/withServiceAssignments';
import withServicesDataManagement from '../hoc/assignments/withServicesDataManagement';
import withTableHandlers from '../hoc/assignments/withTableHandlers';
import withBarbersByShop from '../hoc/assignments/withBarbersByShop';
import fetchServiceOnMount from '../hoc/fetchServiceOnMount';

export default compose(
  fetchServiceOnMount(),
  withRouter,
  withBarbersByShop,
  withShopExpander,
  withEntitiesLoading,
  withServiceAssignments,
  withServicesDataManagement,
  withTableHandlers,
  withHandlers({
    isSelected: props => row => !!getAssignment(props.serviceAssignments, row),
    getValue: props => (row, fieldName) => getFieldValue(props.service, props.serviceAssignments, row, fieldName),
    isLoading: props => (row) => {
      const entityPath = getPath(row);
      const entityPathString = entityPath.toString();
      return props.entitiesLoading.includes(entityPathString);
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.service !== this.props.service) {
        const assignments = this.props.roleIdType.type === 'brand' ?
          (this.props.service.assignments || []) :
          [{ ...this.props.service, assigneeId: this.props.roleIdType.id }];
        this.props.setServiceAssignments(convertAssignmentsIntoObject(assignments));
      }
    },
  }),
)(Assignments);
